var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ep:platform"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.875 27.625V25.5H19.125V27.625H25.5V29.75H8.5V27.625H14.875ZM4.25 23.375V4.25H29.75V23.375H4.25Z",
    fill: "#699BF7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.14857988c50bee739ffca953ea7baeea.svg";
export { ForwardRef as ReactComponent };